document.addEventListener("DOMContentLoaded", function () {
  const emrSearchInput = document.getElementById("emr-input-search");
  const emrSearchModal = document.querySelector(".emr-search-modal");
  const emrSearchOverlay = document.querySelector(".emr-search-overlay");
  const emrCloseSearch = document.querySelector(".emr-close-search");

  let searchTimeout;

  if (emrSearchInput) {
    emrSearchInput.addEventListener("focus", function () {
      emrSearchModal.style.removeProperty("display");
      emrSearchModal.style.display = "block";
      emrSearchModal.classList.add("active");
      emrSearchOverlay.style.display = "block";
      emrSearchOverlay.classList.add("active");
    });

    emrSearchInput.addEventListener("input", function () {
      const query = this.value.trim();

      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      if (query.length >= 2) {
        searchTimeout = setTimeout(() => {
          emr_search_fetch();
        }, 300);
      } else {
        document.getElementById("emr-search-results").innerHTML = "";
        emrSearchModal.classList.remove("wrapped");
      }
    });

    emrSearchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        const query = this.value.trim();
        if (query) {
          const searchUrl = `/?s=${encodeURIComponent(
            query
          )}&post_type[]=emr-materia&post_type[]=emr-receita`;
          window.location.href = searchUrl;
        }
      }
    });
  }

  if (emrCloseSearch) {
    emrCloseSearch.addEventListener("click", closeEmrSearch);
  }

  if (emrSearchOverlay) {
    emrSearchOverlay.addEventListener("click", closeEmrSearch);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      emrSearchModal.classList.remove("active");
      emrSearchOverlay.style.display = "none";
      emrSearchOverlay.classList.remove("active");
      emrSearchModal.classList.remove("wrapped");
      emrSearchInput.value = "";
      document.getElementById("emr-search-results").innerHTML = "";
      emrSearchModal.style.display = "block";

      emrSearchInput.blur();
    }
  });

  function closeEmrSearch() {
    emrSearchModal.classList.remove("active");
    emrSearchOverlay.style.display = "none";
    emrSearchOverlay.classList.remove("active");
    emrSearchModal.classList.remove("wrapped");
    emrSearchInput.value = "";
    document.getElementById("emr-search-results").innerHTML = "";

    emrSearchModal.style.display = "block";

    emrSearchInput.blur();
  }

  document.addEventListener("click", function (e) {
    if (
      emrSearchModal &&
      !emrSearchModal.contains(e.target) &&
      !emrSearchInput.contains(e.target) &&
      emrSearchModal.style.display === "block"
    ) {
      emrSearchModal.classList.remove("active");
      emrSearchOverlay.style.display = "none";
      emrSearchOverlay.classList.remove("active");
      emrSearchModal.classList.remove("wrapped");
      emrSearchInput.value = "";
      document.getElementById("emr-search-results").innerHTML = "";

      emrSearchModal.style.display = "block";

      emrSearchInput.blur();
    }
  });
});

function emr_search_fetch() {
  const query = document.getElementById("emr-input-search").value.trim();

  if (!query) return;

  const resultsContainer = document.getElementById("emr-search-results");

  const ajaxUrl =
    typeof THEME !== "undefined" && THEME.URL && THEME.URL.AJAX
      ? THEME.URL.AJAX
      : "/wp-admin/admin-ajax.php";

  jQuery.ajax({
    url: ajaxUrl,
    type: "POST",
    data: {
      action: "emr_data_fetch",
      keyword: query,
    },
    success: function (data) {
      resultsContainer.innerHTML = data;
      document.querySelector(".emr-search-modal").classList.add("wrapped");
      document.querySelector(".emr-search-modal").style.display = "block";
    },
    error: function () {
      resultsContainer.innerHTML =
        '<div class="emr-error">Erro ao buscar. Tente novamente.</div>';
    },
  });
}
